import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidatePreviewPayGateRefundPaymentResponse from "./customerRefundCandidatePreviewPayGateRefundPaymentResponse";
import CustomerRefundCandidatePreviewTransferRefundPaymentResponse from "./customerRefundCandidatePreviewTransferRefundPaymentResponse";
import RefundPaymentType from "./refundPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePreviewRefundPaymentResponse {
  @observable
  paymentType!: RefundPaymentType;

  /**
   * Refund payment is transferred to SEPA.
   */
  @observable
  isTransferredToSepa!: boolean;

  @observable
  @Type(() => CustomerRefundCandidatePreviewTransferRefundPaymentResponse)
  transferPayment?: CustomerRefundCandidatePreviewTransferRefundPaymentResponse;

  @observable
  @Type(() => CustomerRefundCandidatePreviewPayGateRefundPaymentResponse)
  payGatePayment?: CustomerRefundCandidatePreviewPayGateRefundPaymentResponse;
}
